import __var_0__ from '@stdlib/vendor/debug.js';
import __var_1__ from './../../events/index.js';
import __var_2__ from './../../validators/width.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var logger = __var_0__;
var events = __var_1__;
var isValid = __var_2__;


// VARIABLES //

var debug = logger( 'clippath:set:width' );
var CHANGE_EVENT = events( 'width' );


// MAIN //

/**
* Sets the width.
*
* @private
* @param {PositiveNumber} width - width
* @throws {TypeError} must be a positive number
*/
function set( width ) {
	/* eslint-disable no-invalid-this */
	var err = isValid( width );
	if ( err ) {
		throw err;
	}
	debug( 'Current value: %d.', this._width );

	this._width = width;
	debug( 'New value: %d.', this._width );

	this.emit( CHANGE_EVENT );
}


// EXPORTS //
export default set;
